export default __webpack_public_path__ + "assets/71400ac54640309f7c31e5e50d20a661.png";